import popper from 'popper.js';
Object.assign(window, { Popper: popper });
